import React from "react";
import { Box } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import OwnerWorkspaceNavigation from "./components/OwnerWorkspaceNavigation";
import OwnerVoiceOperatorPanel from "./voice/OwnerVoiceOperatorPanel";
import OwnerJarvis2 from "./center/OwnerJarvis2";
import { OwnerVoiceOperatorProvider } from "./voice/OwnerVoiceOperatorContext";
import { useOwnerJarvisRuntime } from "./jarvis/useOwnerJarvisRuntime";

export default function OwnerJarvisWorkspace() {
  const navigate = useNavigate();
  const location = useLocation();
  const jarvis = useOwnerJarvisRuntime({ navigate });
  const isOwnerHome = /^\/dashboard\/owner\/?$/.test(location.pathname);

  return (
    <OwnerVoiceOperatorProvider
      actions={jarvis.actions}
      introMessage={jarvis.introMessage}
      onUnhandledUtterance={jarvis.onUnhandledUtterance}
      alwaysOn
      routeContext={location.pathname}
      loadNavigationLearning={jarvis.loadNavigationLearning}
      recordNavigationLearning={jarvis.recordNavigationLearning}
    >
      <Box
        sx={{
          width: "100%",
          height: { xs: "auto", md: "calc(100dvh - 68px)" },
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: { xs: "visible", md: "hidden" },
          bgcolor: "background.default",
        }}
      >
        <Box
          sx={{
            position: "sticky",
            top: { xs: "calc(56px + env(safe-area-inset-top))", sm: "calc(64px + env(safe-area-inset-top))", md: 0 },
            zIndex: 1080,
            flex: "0 0 auto",
            minWidth: 0,
            px: { xs: .45, sm: .65 },
            py: .2,
            bgcolor: "rgba(var(--wp-panel-surface-rgb, 255,255,255),.97)",
            borderBottom: "1px solid",
            borderColor: "divider",
            backdropFilter: "blur(12px)",
          }}
        >
          <OwnerVoiceOperatorPanel persistent pathname={location.pathname} />
        </Box>

        <Box sx={{ display: "flex", flex: "1 1 auto", minHeight: 0, minWidth: 0 }}>
          <OwnerWorkspaceNavigation />
          <Box
            component="section"
            sx={{
              flex: "1 1 auto",
              minWidth: 0,
              minHeight: 0,
              overflow: { xs: "visible", md: "auto" },
              overscrollBehavior: "contain",
              px: { xs: .55, sm: .9, md: 1.15 },
              py: { xs: .55, md: .9 },
              "& > *": { maxWidth: "none !important", mx: "0 !important" },
            }}
          >
            {!isOwnerHome ? <Box sx={{ mb: .75 }}><OwnerJarvis2 compact /></Box> : null}
            <Outlet />
          </Box>
        </Box>
      </Box>
    </OwnerVoiceOperatorProvider>
  );
}
